import React from 'react';
import SyncStatus from '../../models/enums/sync-status';
import { SyncErrorIcon, SyncIcon } from '@common/utils/icons/icons';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const CustomSyncIcon: React.FC<{ status: SyncStatus }> = ({ status }) => {
  return status === SyncStatus.FAILED ? (
    <SyncErrorIcon />
  ) : status === SyncStatus.SUCCEEDED ? (
    <SyncIcon />
  ) : (
    <Box
      sx={(theme) => ({
        position: 'relative',
        height: theme.spacing(3),
        width: theme.spacing(3),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-around',
      })}
    >
      <SyncIcon color="disabled" fontSize="small" />
      <CircularProgress size={24} sx={{ position: 'absolute', left: 2 }} />
    </Box>
  );
};

export default CustomSyncIcon;
